<!-- Modal genérico para los descuentos -->
<!-- ################################## -->
<div class="d-flex justify-content-center">
    <div class="modal fade my-bs-modal" id="discount-modal" tabindex="-1" aria-labelledby="exampleModalLabel"
        aria-hidden="true">
        <div class="modal-dialog modal-xl">
            <div class="modal-content rounded w-100">

                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="exampleModalLabel">
                        <strong>{{ 'tuition-calc.discId' | translate }}:</strong>
                        {{ disc.idDiscountCode }}
                    </h1>
                </div>

                <div class="modal-body">
                    <div class="row justify-content-center">
                        <div class="d-flex flex-wrap justify-content-center">

                            <div class="card-body">
                                <ul class="list-group list-group-flush mt-2">
                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span class="mt-3">
                                            <strong>{{ 'tuition-calc.traductionVat' | translate }}</strong>
                                        </span>
                                    </li>

                                    @for (trDisc of disc.listDiscountsAppliedTraduction; track $index) {
                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span class="text-muted">
                                            {{ trDisc.isoLanguageCode == 'es' ? 'Español' :
                                            trDisc.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés' }}
                                        </span>
                                        <span>{{ trDisc.description == null ? 'Not description' : trDisc.description }}</span>
                                    </li>
                                    }
                                    
                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.fixedDiscount' | translate }}</span>
                                        <strong>{{ disc.fixedDiscountAmount }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.discountPercentage' | translate }}</span>
                                        <strong>{{ disc.configuredDiscountPercentage }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.appliedDisc' | translate }}</span>
                                        <strong>{{ disc.appliedDiscountAmount }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.appliedDisc' | translate }}</span>
                                        <strong>{{ disc.appliedDiscountAmountStudent }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.appliedDiscCompany' | translate }}</span>
                                        <strong>{{ disc.appliedDiscountAmountCompany }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span class="mt-3">
                                            <strong>{{ 'tuition-calc.listSensitiveTraduction' | translate
                                                }}</strong>
                                        </span>
                                    </li>

                                    @for (trDisc of disc.listOfSensitiveDataTraduction; track $index) {
                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span class="text-muted">
                                            {{ trDisc.isoLanguageCode == 'es' ? 'Español' :
                                            trDisc.isoLanguageCode == 'ca' ? 'Catalán' : 'Inglés' }}
                                        </span>
                                        <span>{{ trDisc.description == null ? 'Not description' : trDisc.description }}</span>
                                    </li>
                                    }

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.bonusTercer' | translate }}</span>
                                        <strong>{{ disc.idStudentPersonalBonusTercer }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.validDiscTercer' | translate }}</span>
                                        <strong>{{ disc.validDiscountIndicatorTercer }}</strong>
                                    </li>

                                    <li class="list-group-item py-2 d-flex justify-content-between">
                                        <span>{{ 'tuition-calc.manualValidation' | translate }}</span>
                                        <strong>{{ disc.manualValidation == null ? 'null' : disc.manualValidation }}</strong>
                                    </li>
                                </ul>
                            </div>
                        </div>

                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" 
                    (click)="hideDiscountModal()">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>